import { ReactComponent as Back15OutlinedIcon } from 'assets/icons/back-15-outlined.svg';

export default Back15OutlinedIcon;
